<template>
    <select
        :name="name"
        v-model="selectedManager"
        class="border-0 bg-transparent p-0 fw-semibold select2"
        :style="style"
        required
    >
        <slot></slot>
    </select>
</template>

<script>
import $ from 'jquery';
import 'select2';
import {setManagerSelected} from './store/flowState';

export default {
    name: 'ManagerSelector',
    props: {
        name: {type: String, required: true},
        // eslint-disable-next-line vue/no-reserved-props
        style: {type: String, default: ''},
    },
    data() {
        return {selectedManager: ''};
    },
    mounted() {
        const vm = this;

        $(this.$el).select2().on('change', function () {
            vm.selectedManager = $(this).val();
            setManagerSelected(!!vm.selectedManager);
        });
    },
    beforeUnmount() {
        $(this.$el).off().select2('destroy');
    },
};
</script>
